(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["il-product-device-check"] && !Shopify.designMode) return;
  try {
    (function(){
 function init(){
  document.querySelectorAll('[data-il-product-check]').forEach(function(notice){
   if(notice.dataset.ready)return;notice.dataset.ready='true';
   const root=notice.closest('.shopify-section')||document.getElementById('MainContent');
   if(!root)return;
   function place(){
    const labels=Array.from(root.querySelectorAll('.il-device-label,.il-honor-device-label,#il-samsung-device-label,.compat-box'));
    const label=labels.find(el=>!el.hidden&&el.getClientRects().length&&getComputedStyle(el).display!=='none');
    const fallback=root.querySelector('.product-detail__short-description');
    const anchor=label||(fallback&&fallback.getClientRects().length?fallback:null);
    if(anchor&&anchor.nextElementSibling!==notice)anchor.insertAdjacentElement('afterend',notice);
   }
   place();const observer=new MutationObserver(place);observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','style']});
   setTimeout(()=>{place();observer.disconnect();},6000);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
